<div class="modal modal--fullBleed modal--noClose">
  <div class="dupe-dialog__wrapper">
    <span *ngIf="!isInCampaign"
          class="dupe-dialog__preheader dupe-dialog__preheader--notInCampaign">
      <i class="fal fa-exclamation-triangle"></i> Not in Campaign
    </span>
    <span *ngIf="isInCampaign"
          class="dupe-dialog__preheader dupe-dialog__preheader--inCampaign">
      <i class="fal fa-circle-check"></i> Entity in Campaign
    </span>
    <h2 class="h2 bot-0025 mt-0100">{{entity | fullName }}</h2>


    <div>
      <div class="dupe-dialog__content flex flexJustify--between">
        <!-- [ngClass]="(!isInCampaign) ?'flex flexJustify--between' : '' " -->
        <div class="col--050">
          <!-- [ngClass]="(!isInCampaign) ?'col--050' : '' " -->
          <div *ngIf="entityType?.emailEnabled">
            <div class="recap__label">Email</div>
            <ng-container *ngIf="entity.bestEmail">
              <a class="link link--small link--noline link--black"
                 href="mailto:{{entity.bestEmail.email}}">{{entity.bestEmail?.email}}</a>
              <i class="far fa-check pair__verified ml-0025"
                 *ngIf="entity.bestEmail?.status === 'verified'"
                 matTooltip="Confirmed"
                 matTooltipPosition="left"></i>
            </ng-container>

            <span *ngIf="!entity.bestEmail"> &mdash; </span>
          </div>

          <div *ngIf="entityType?.phoneNumberEnabled">
            <div class="recap__label">Phone</div>
            <ng-container *ngIf="entity.bestPhoneNumber?.number">
              <a class="link link--small link--noline link--black"
                 href="tel:{{entity.bestPhoneNumber?.number}}">{{entity.bestPhoneNumber?.number | phone}}
                {{entity.bestPhoneNumber?.ext ? 'Ext. ' + entity.bestPhoneNumber.ext : ''}}</a>
              <i class="far fa-check pair__verified ml-0025"
                 *ngIf="entity.bestPhoneNumber?.status === 'verified'"
                 [matTooltip]="'Confirmed'"
                 [matTooltipPosition]="'left'"></i>
            </ng-container>
            <span *ngIf="!entity.bestPhoneNumber?.number"> &mdash; </span>

          </div>

          <div *ngIf="entityType?.addressEnabled">
            <div class="recap__label">Address</div>
            <ng-container *ngIf="entity.bestAddress">
              <span class="link link--small link--noline link--black"
                    data-test-id="pcentity.bestAddress">
                <full-address class="full-address link--black"
                              [address]="entity.bestAddress"></full-address>
              </span>
              <i class="far fa-check pair__verified ml-0025"
                 *ngIf="entity.bestAddress?.status === 'verified'"
                 [matTooltip]="'Confirmed'"
                 [matTooltipPosition]="'left'"></i>
            </ng-container>
            <span *ngIf="!entity.bestAddress"> &mdash; </span>

          </div>
        </div>
        <div class="col col--050"
             *ngIf="!loading">
          <div>
            <div class="recap__label">Entity Found In</div>
            <div class="recap__value">
              <span *ngFor="let campaign of displayedCampaignNames"
                    class="d-block">{{campaign}}</span>
              <span class="uppercase"
                    *ngIf="notDisplayedCount > 0"
                    style="font-size: 11px">
                + {{notDisplayedCount}} more {{notDisplayedCount === 1 ? 'campaign' : 'campaigns'}}
              </span>
            </div>
          </div>
        </div>
      </div><!-- /dupe-dialog__content -->



      <div class="flex flexJustify--center"
           style="margin: 1.5rem auto 1.5rem;">
        <button class="btn"
                [ngClass]="(!isInCampaign) ?'btn--orange' : 'btn--green' "
                style="margin-left: 0.5rem; margin-right: 0.5rem;"
                [mat-dialog-close]="entity">
          <span *ngIf="!isInCampaign">Add this Entity to current Campaign</span>
          <span *ngIf="isInCampaign">View this Entity</span>
        </button>
      </div>

    </div>
    <mat-dialog-actions class="skipCreate flex flexJustify--center"
                        style="margin-bottom: 0;">
      <button class="btn btn--sm btn--white"
              type="button"
              role="button"
              aria-details="Go Back"
              [mat-dialog-close]="false">
        <i class="fal fa-arrow-left pr-0025"></i> Go Back</button>
    </mat-dialog-actions>
  </div>

</div>
